export default "__VITE_ASSET__D6o$1djO__"